@switch (column.type) {
  @case (TABLE_COLUMN_TYPE.TEXT) {
    <div class="text-{{ column.bodyAlign }} {{ column.customBodyClass }}">
      {{ item[column.viewKey] ? item[column.viewKey] : "-" }}
    </div>
  }

  @case (TABLE_COLUMN_TYPE.CUSTOM_DATE) {
    <div class="text-{{ column.bodyAlign }} {{ column.customBodyClass }}">
      {{ item[column.viewKey] | dateToTimeAgo }}
    </div>
  }

  @case (TABLE_COLUMN_TYPE.DATE_TIME) {
    <div class="text-{{ column.bodyAlign }} {{ column.customBodyClass }}">
      {{ !item[column.viewKey] || item[column.viewKey] === "-" ? "-" : (item[column.viewKey] | date: "d-MMM-yy, h:mm a") }}
    </div>
  }

  @case (TABLE_COLUMN_TYPE.DATE) {
    <div class="text-{{ column.bodyAlign }} {{ column.customBodyClass }}">
      {{ !item[column.viewKey] || item[column.viewKey] === "-" ? "-" : (item[column.viewKey] | date: "d-MMM-yy") }}
    </div>
  }

  @case (TABLE_COLUMN_TYPE.ACTION) {
    <div class="justify-content-{{ column.bodyAlign }} {{ column.customBodyClass }} d-flex gap-2">
      <div [innerHtml]="ICONS.EDIT_ICON('var(--gray-light-4)', 20, 20) | sanitizer: 'html'" (click)="$event.stopPropagation(); column.onEdit ? column.onEdit(item) : null"></div>
      <div [innerHtml]="ICONS.DELETE_ICON('var(--gray-light-4)', 20, 20) | sanitizer: 'html'" (click)="$event.stopPropagation(); column.onDelete ? column.onDelete(item) : null"></div>
    </div>
  }
}
